import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-section-trials',
  templateUrl: './section-trials.component.html',
  standalone: true,
  imports: [CommonModule,
    NgOptimizedImage,
    MatButtonModule,
    TranslateModule,
    SharedModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./section-trials.component.scss']
})
export class SectionTrialsComponent {

  constructor(private router: Router,
    private routerService: Router
  ){}
  productTrials = [
    // {
    //   image: '/images/products/marker-logo.svg',
    //   title: 'Marker',
    //   description: 'freetrials.marker_description',
    // },
    {
      image: '/images/products/solveUp-logo.svg',
      title: 'SolveUp',
      description: 'freetrials.solveUp_description',
      sku:'solveUp'
    },
    {
      image: '/images/products/driveMyJob-logo.svg',
      title: 'DriveMyJob',
      description: 'freetrials.driveMyJob_description',
      sku:'driveMyJob'
    },
    // {
    //   image: '/images/products/videoSop-logo.svg',
    //   title: 'VideoSop',
    //   description: 'freetrials.videoSop_description',
    //   'sku':'videosop'
    // },
  ]

  trackByFn(index: number, item: any) {
    return index;
  }
  goToMarketplace() {
    this.router.navigate([environment.routingBasePath + '/marketplace']);
  }
  goToProduct(sku: any) {
    this.routerService.navigate([environment.routingBasePath + '/product/' + sku]);
  }

}
